// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { Log, LogLevel } from "./log.js";
class Context {
    constructor(options = {}) {
        this.options = {};
        this.log = new Log(this);
        this.options = options;
        this.jws = {};
        this.flat = { header: '', payload: '', signature: '' };
    }
    get errors() {
        const errors = this.log.entries(LogLevel.ERROR);
        return errors.length ? errors : undefined;
    }
    get warnings() {
        const warnings = this.log.entries(LogLevel.WARNING).filter(le => le.level === LogLevel.WARNING);
        return warnings.length ? warnings : undefined;
    }
}
export default Context;
